import { render, staticRenderFns } from "./DistrictManage.vue?vue&type=template&id=4484fe67&scoped=true&"
import script from "./DistrictManage.vue?vue&type=script&lang=js&"
export * from "./DistrictManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484fe67",
  null
  
)

export default component.exports